import { defineStore } from "pinia";
import Api from "@/api/Api";

const apiInstance = new Api();

export const useProdutoStore = defineStore("produtoStore", {
    state: () => ({
        produtos: [],
        produtosFiltrados: []
    }),
    actions: {
        async listarProdutos(lojaId) {
            try {
                const response = await apiInstance.getDataApi(`/api/listar-produtos-landing/${lojaId}`);

                if (response.status && response.data?.produtos) {
                    this.produtos = response.data.produtos;
                    this.produtosFiltrados = response.data.produtos;
                } else {
                    this.produtos = [];
                    this.produtosFiltrados = [];
                    console.warn("Erro ao listar produtos landing.");
                }

                return response;
            } catch (error) {
                console.error('Erro ao listar produtos landing:', error);
                this.produtos = [];
                this.produtosFiltrados = [];
            }
        },
    }
});